import { about } from "@/data/siteConfig";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { MediaPlaceholder } from "@/components/MediaPlaceholder";
import { Manifesto } from "@/components/home/Manifesto";
import { ContactCTA } from "@/components/home/ContactCTA";
import { Reveal } from "@/components/Reveal";

export default function About() {
  return (
    <>
      <Seo
        title="About Jose Velasco"
        description="Velasco Lock and Safe is led by Jose Velasco — a hands-on locksmith and safe specialist based in Norwalk, California, known for taking on difficult safe work and communicating directly with every customer."
        path="/about"
      />
      <PageHero
        overline="About"
        title="Meet Velasco Lock and Safe"
        description={about.lead}
        showCall={false}
      />

      <section className="bg-ink py-20 md:py-28">
        <div className="mx-auto max-w-[1440px] px-5 md:px-8">
          <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
            <Reveal>
              <MediaPlaceholder
                src="/media/about-jose.jpg"
                alt="Jose Velasco of Velasco Lock and Safe with a team member and a safe on the moving trailer"
                aspect="aspect-[4/3]"
              />
            </Reveal>
            <div>
              <h2 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                {about.headline}
              </h2>
              <div className="mt-6 space-y-4 text-lg leading-relaxed text-steel">
                {about.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Manifesto />
      <ContactCTA />
    </>
  );
}
